module.exports = "https://assets.pclncdn.com/web/next-landing/967f96dee0/_next/static/images/Three-a112201b65eb30d1dfecbdd118ebcc92.svg";